export const seconds2StringFormat = seconds => {
  var minutes = Math.floor(seconds / 60)
  var partInSeconds = seconds % 60
  minutes = minutes.toString().padStart(2, "0")
  partInSeconds = partInSeconds.toString().padStart(2, "0")
  return `${minutes}:${partInSeconds}`
}
